"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ColumnConfig_1 = tslib_1.__importDefault(require("./ColumnConfig"));
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const fmko_ts_common_1 = require("fmko-ts-common");
class StyledOnStringColumnConfig extends ColumnConfig_1.default {
    constructor(header, headerStyle, mapDataToField, columnStyle, sortable = false, clickable = false, footer) {
        super(header, headerStyle, mapDataToField, sortable, clickable, footer);
        this.renderer = {
            render(ctx, field) {
                // Style the column based on the text that is rendered
                if (field instanceof fmko_ts_common_1.Widget) {
                    const style = columnStyle(field.element.textContent);
                    Object.assign(field.getCssStyle(), style);
                    ctx.setWidget(field);
                }
                else {
                    const style = columnStyle(field);
                    const textToRender = (0, fmko_ts_common_1.htmlEncode)(field);
                    const div = new fmko_ts_widgets_1.HTML(textToRender);
                    Object.assign(div.getCssStyle(), style);
                    ctx.setWidget(div);
                }
            },
            canRender(o) {
                return true;
            }
        };
    }
    /**
     * Map a field to a string, the constructor forces (data: T) => string, therefore we can use "as string"
     * @param {T} data
     * @returns {string}
     */
    getData(data) {
        return this.mapDataToTD(data);
    }
}
exports.default = StyledOnStringColumnConfig;
//# sourceMappingURL=StyledOnStringColumnConfig.js.map